<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-grid slds-wrap">
  <div #chart [id]="id" class="slds-col">
    <div [id]="tooltipId" class="tls-tooltip"></div>
    <div>{{message}}</div>
  </div>

  <div class="slds-col slds-m-top_small tls-right">
    <div *ngFor="let legend of legends"
         [style.background]="legend.background" class="tls-legend">
      <span [style.background]="legend.color" class="tls-legend-label">{{legend.label}}:</span>
      <span class="tls-legend-value">{{legend.value}}</span>
      <span class="tls-legend-value-c">{{legend.valueCumulated}}</span>
    </div>
  </div>
</div>

<div *ngIf="isDebug">
  <hr/>
  {{info}}
  <!--div>
    Definitions:
    <small class="tls-debugx">{{ definition | json }}</small>
  </div-->
  <!--div>
    Current Sources:
    <small class="tls-debugX">{{ currentSources | json }}</small>
  </div-->
  <!-- div>
    Segments:
    <small class="tls-debug">{{ segments | json }}</small>
  </div>
  <div>
    Sources:
    <small class="tls-debugX">{{ sources | json }}</small>
  </div-->


</div>
